import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WeeklySchedule from '@/pages/home/components/WeeklySchedule';

export default function SchedulePage() {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Weekly Class Schedule at HUB30 | Timetable – Jbeil, Lebanon</title>
        <meta
          name="description"
          content="View the full weekly class timetable at HUB30 gym in Jbeil — CrossFit, calisthenics, mobility, and more. Find the session that fits your schedule."
        />
        <meta
          name="keywords"
          content="gym schedule Jbeil, class timetable Lebanon, CrossFit schedule Byblos, weekly gym classes Jbeil, fitness timetable Lebanon"
        />
        <link rel="canonical" href="https://hub30gym.com/schedule" />
        <meta property="og:title" content="Weekly Class Schedule at HUB30 | Jbeil, Lebanon" />
        <meta property="og:description" content="Full weekly timetable for CrossFit, calisthenics, mobility, and more at HUB30 gym in Jbeil." />
        <meta property="og:url" content="https://hub30gym.com/schedule" />
      </Helmet>
      <Navbar />
      <div className="pt-20">
        <WeeklySchedule />
      </div>
      <Footer />
    </div>
  );
}
